import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import { get } from 'lodash';
import classNames from 'classnames';
import Conversation from '../Conversation/Conversation';
import ScoreCell from '../../Table/ScoreCell/ScoreCell';
import {
  SELECT_CONVERSATION,
  FETCH_SINGLE_CONVERSATION,
  TOGGLE_CONVERSATION_BOLD,
  SET_SEEN_BY_DEALER,
} from '../../../redux/Conversations';
import './ConversationsTable.scss';
import { compose } from 'redux';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';
import { t } from 'i18next';

const totalConversationsMock = 30;

class ConversationsTable extends PureComponent {
  componentWillUnmount() {
    const { selectConversation } = this.props;
    selectConversation(null);
  }
  selectItem = (hashId, id) => {
    const {
      selectConversation,
      toggleConversationBold,
      fetchSingleConversation,
      setSeenByDealer,
      conversations,
    } = this.props;
    selectConversation(hashId);
    toggleConversationBold(hashId);
    const targetConversation = get(conversations, [hashId]);
    if (get(targetConversation, 'messages')) {
      if (get(targetConversation, 'bold')) {
        setSeenByDealer(get(targetConversation, 'id'));
      }
    } else {
      fetchSingleConversation(id, hashId);
    }
  }

  renderItems = () => {
    const { conversations } = this.props;

    if (conversations && Object.keys(conversations).length === 0) {
      return <span className="no-conversations">{t('no_conversations')}</span>;
    }

    const sortedConversations = Object.values(conversations).sort((conv1, conv2) => {
      return new Date(conv1.last_message) < new Date(conv2.last_message) ? 1 : -1;
    });
    return sortedConversations.map((converation) => {
      return this.renderItem(converation);
    });
  }

  renderItem = (item) => {
    const { selectedItemHashId } = this.props;
    const itemHashId = get(item, 'offer_hash_id');
    const conversationLabel = get(item, 'label');
    const infoString = `${itemHashId}  ${get(item, 'display_folder')}`;
    const formattedDate = moment(get(item, 'last_message')).format('DD/MM/YYYY HH:mm');
    const itemClasses = classNames('conversation-item', { bold: get(item, 'bold'), active: selectedItemHashId === itemHashId });
    return (
      <div key={itemHashId} className={itemClasses} onClick={() => this.selectItem(itemHashId, get(item, 'id'))}>
        <ScoreCell score={get(item, 'score')} hideImage returnAsDiv />
        <div className="converation-item__right">
          <div className="conversation-item__right-content">
            <div className="conversation-item__info">
              <span className="model-string">{conversationLabel}</span>
              <span className="info-string">{infoString}</span>
            </div>
            <span className="conversation-item__day">
              {formattedDate}
            </span>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { translations, conversations } = this.props;
    const shouldMoreShow = conversations.length < totalConversationsMock;
    return (
      <div className="conversations-table">
        <div className="conversations-list">
          {this.renderItems()}
          {shouldMoreShow && <span className="conversations-more"><span>{get(translations,'show_older')}</span></span>}
        </div>
        <div className="conversation-details">
          <Conversation />
        </div>
      </div>
    );
  }
}

ConversationsTable.propTypes = {
  t: PropTypes.func.isRequired,
  selectConversation: PropTypes.func.isRequired,
  fetchSingleConversation: PropTypes.func.isRequired,
  toggleConversationBold: PropTypes.func.isRequired,
  setSeenByDealer: PropTypes.func.isRequired,
  selectedItemHashId: PropTypes.string,
};

ConversationsTable.defaultProps = {
  conversations: null,
  selectedItemHashId: null,
};

const mapStateToProps = (state) => {
  return {
    conversations: get(state, ['conversations', 'conversations']),
    selectedItemHashId: get(state, ['conversations', 'selectedItemHashId']),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    selectConversation: hashId => dispatch(SELECT_CONVERSATION({ hashId })),
    fetchSingleConversation: (id, hashId) => dispatch(FETCH_SINGLE_CONVERSATION({ id, hashId })),
    toggleConversationBold: (hashId, value) => dispatch(TOGGLE_CONVERSATION_BOLD({ hashId, value })),
    setSeenByDealer: conversationId => dispatch(SET_SEEN_BY_DEALER({ conversationId })),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withScopedTranslations('tables.conversations')
)(ConversationsTable);
